import _Object$assign from "@babel/runtime-corejs3/core-js/object/assign";
function genDefaultParamsDealFn(p) {
  return function (r) {
    return _Object$assign(_Object$assign({}, p), r);
  };
}
;
export { genDefaultParamsDealFn };


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/lib/helper/apiHelper.js
// module id = null
// module chunks = 